import crypto from 'crypto';
import { getGikeyValue } from '../../utils/moveTo';

function useCrypto() {
    const algorithm = process.env.REACT_APP_0X1A9F7LC2G3B7O91;

    let _16 = process.env.REACT_APP_0X4F9I8A1D2C3E7V5;
    let _32 = process.env.REACT_APP_0X123KB7E8C7A9Y1E;

    _16 = getGikeyValue(_16, 16);
    _32 = getGikeyValue(_32, 32);

    const encryptRequest = (data) => {
        const cipher = crypto.createCipheriv(algorithm, _32, _16);
        const encrypted = Buffer.concat([cipher.update(data), cipher.final()]);
        return {
            iv: _16.toString('base64'),
            content: encrypted.toString('base64')
        };
    }

    const decryptRequest = (text) => {
        if (text !== "" && text !== undefined) {
            // let div = Buffer.from(_16, 'base64');
            let encryptedText = Buffer.from(text, 'base64');
            let decipher = crypto.createDecipheriv(algorithm, Buffer.from(_32), _16);
            let decrypted = decipher.update(encryptedText);
            decrypted = Buffer.concat([decrypted, decipher.final()]);
            return decrypted.toString();
        }
    }

    const encodeNumberToBase64 = (number) => {
        // Convert the number to a string
        const numberString = number?.toString();

        // Encode the string using btoa
        const base64EncodedString = btoa(numberString);

        return base64EncodedString;
    }

    return {
        encryptRequest,
        decryptRequest,
        encodeNumberToBase64
    }
}

export default useCrypto;